// SALVUS frontend working code

// import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
// import DashboardIcon from "@mui/icons-material/Dashboard";
// import GroupIcon from "@mui/icons-material/Group";
// import InboxIcon from "@mui/icons-material/Inbox";
// import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
// import SupportIcon from "@mui/icons-material/Support";
// import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
// import DataObjectIcon from "@mui/icons-material/DataObject";
// import React from "react";
// import { Link, useLocation } from "react-router-dom";
// import Header from "../Header/Header";

// const Layout = ({ children }) => {
//   const location = useLocation();

//   return (
//     <>
//       <Header />
//       <div className="layout">
//         <div className="sidebar">
//           <Link
//             to="/home"
//             className={`${location.pathname === "/home" ? "active" : ""}`}
//           >
//             <DashboardIcon />
//             Dashbord
//           </Link>
//           <Link
//             to="/metadata"
//             className={`${location.pathname === "/metadata" ? "active" : ""}`}
//           >
//             <DataObjectIcon />
//             Metadata
//           </Link>
//           <Link
//             to="/products"
//             className={`${location.pathname === "/products" ? "active" : ""}`}
//           >
//             <QrCodeScannerIcon />
//             Product
//           </Link>
//           <Link
//             to="/app-users"
//             className={`${location.pathname === "/app-users" ? "active" : ""}`}
//           >
//             <GroupIcon />
//             Users
//           </Link>
//           {/* <Link to="/events" className={`${location.pathname.includes('events') ? 'active' : ""}`}>
//                         <AccountBalanceWalletIcon />
//                         Events
//                     </Link> */}
//           {/* <Link to="/qr-requests" className={`${location.pathname === '/qr-requests' ? 'active' : ""}`}>
//                         <InboxIcon />
//                         QR Request
//                     </Link> */}
//           <Link
//             to="/user-issues"
//             className={`${
//               location.pathname === "/user-issues" ? "active" : ""
//             }`}
//           >
//             <SupportIcon />
//             User Issue
//           </Link>
//           {/* <Link to="/admin-user" className={`${location.pathname === '/admin-user' ? 'active' : ""}`}>
//                         <AdminPanelSettingsIcon />
//                         Admin
//                     </Link> */}
//         </div>
//         <div className="content">{children}</div>
//       </div>
//     </>
//   );
// };

// export default Layout;




//AUTHORIZED ROUTES DEMO APP CHANGES
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import SupportIcon from "@mui/icons-material/Support";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DataObjectIcon from "@mui/icons-material/DataObject";
import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import Header from "../Header/Header";
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Layout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const navItems = [
    { to: "/home", label: "Dashboard", icon: <DashboardIcon /> },
    { to: "/metadata", label: "Metadata", icon: <DataObjectIcon /> },
    { to: "/products", label: "Products", icon: <QrCodeScannerIcon /> },
    { to: "/app-users", label: "Users", icon: <GroupIcon /> },
    { to: "/user-issues", label: "User Issues", icon: <SupportIcon /> },
    { to: "/bank-integration", label: "Bank APIs", icon: <AccountBalanceIcon /> },
    { to: "/admin-user", label: "Admin", icon: <AdminPanelSettingsIcon /> },
  ];

  const drawer = (
    <Box sx={{ width: 280 }}>
      <Toolbar />
      <Box sx={{ px: 2, pb: 1 }}>
        <Box
          sx={{
            p: 2,
            borderRadius: 3,
            color: "primary.contrastText",
            background: "linear-gradient(135deg, #011638 0%, #0b3a7e 100%)",
          }}
        >
          <Box sx={{ fontWeight: 900, fontSize: 16 }}>SEC@R Console</Box>
          <Box style={{ opacity: 0.9, fontSize: 12 }}>Admin & live monitoring</Box>
        </Box>
      </Box>
      <Divider />
      <List sx={{ px: 1 }}>
        {navItems.map((item) => (
          <ListItemButton
            key={item.to}
            component={NavLink}
            to={item.to}
            onClick={() => isMobile && setMobileOpen(false)}
            style={({ isActive }) => ({
              borderRadius: 12,
              margin: "4px 8px",
              background: isActive ? theme.palette.secondary.main : "transparent",
              color: isActive ? theme.palette.primary.main : "inherit",
            })}
          >
            <ListItemIcon sx={{ minWidth: 40, color: "inherit" }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <Header onMenuClick={isMobile ? () => setMobileOpen((v) => !v) : undefined} />
      <Box sx={{ display: "flex", minHeight: "calc(100vh - 64px)" }}>
        {/* Sidebar */}
        <Box
          component="nav"
          sx={{ width: { md: 280 }, flexShrink: { md: 0 } }}
          aria-label="navigation"
        >
          {/* Mobile drawer */}
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={() => setMobileOpen(false)}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": { boxSizing: "border-box", width: 280 },
            }}
          >
            {drawer}
          </Drawer>
          {/* Desktop drawer */}
          <Drawer
            variant="permanent"
            open
            sx={{
              display: { xs: "none", md: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: 280,
                borderRight: "1px solid",
                borderColor: "divider",
              },
            }}
          >
            {drawer}
          </Drawer>
        </Box>

        {/* Content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, sm: 3 },
            bgcolor: "#f7f8fb",
            minWidth: 0,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default Layout;